import React from "react";

import { Stars } from "..";

import "./detailHeader.css";

const DetailHeader = ({
  stars_average,
  reviews,
  students,
  creator_name,
  last_Update,
  language,
  title
}) => {
  return (
    <div className="box">
    <h2 className="text-capitalize mb-3">{title}</h2>
      
      
    </div>
  );
};

export default DetailHeader;
